module.exports = __webpack_public_path__ + "img/banner.4815952f.png";